module.exports = __webpack_public_path__ + "static/media/video.0393b61.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/VX/video.mp4
// module id = j0/f
// module chunks = 1